import Button from "components/common/buttons/buttons";
import { Close, Forward } from "components/common/Icons";
import AccountConnectLeaveModal from "components/modals/KB/AccountConnectLeave";
import dynamic from "next/dynamic";
import { useState, useEffect } from "react";
import { TYPO } from "styles/Typo";

// const PDFViewer: any = dynamic(
//   () => import("components/templates/common/KB/ObligationTermsPdf"),
//   {
//     loading: () => <div className=""></div>,
//     ssr: false,
//   }
// );

const PDFViewer2: any = dynamic(
  () => import("components/templates/common/KB/ObligationTermsPdfver2"),
  {
    loading: () => <div className=""></div>,
    ssr: false,
  }
);

function ObligationTermsNoti({
  setIsObligationTermsModalOpen,
}: {
  setIsObligationTermsModalOpen: any;
}) {
  const [pdfOpen, setPdfOpen] = useState(false);
  const [leaveModalOpen, setLeaveModalOpen] = useState(false);
  const clickHandler = () => {
    setPdfOpen(true);
  };
  if (pdfOpen) {
    return (
      <main
        className={`fixed top-0 left-0 z-[1000] min-w-[360px] max-w-[800px] w-screen bg-white min-h-screen`}
      >
        <PDFViewer2
          setPdfOpen={setPdfOpen}
          setIsObligationTermsModalOpen={setIsObligationTermsModalOpen}
        />
      </main>
    );
  }
  return (
    <main
      className={`fixed top-0 left-0 z-[1000] min-w-[360px] max-w-[800px] w-screen bg-white min-h-screen`}
    >
      <div className="py-[6px] px-[10px] ">
        <div
          className="p-[10px] cursor-pointer"
          onClick={() => {
            setLeaveModalOpen(true);
          }}
        >
          <Close width={24} height={24} fill={"#000"} />
        </div>
      </div>
      <div className="px-6 pt-6 flex flex-col gap-2 mb-4">
        <span className={`${TYPO.TYPO5_1_MD} text-blue40`}>
          새로운 거래소가 열려요
        </span>
        <span className={`${TYPO.TYPO3_SB} text-gray90`}>
          국내주식 거래를 위해
          <br />꼭 확인할 내용이 있어요
        </span>
      </div>
      <div
        className="py-2 cursor-pointer"
        onClick={() => {
          clickHandler();
        }}
      >
        <div className="px-6 py-2 flex items-center justify-between">
          <span className={`${TYPO.TYPO5_1_RG} text-gray70`}>
            최선주문집행 필수 안내
          </span>
          <Forward width={16} height={16} fill={"gray40"} />
        </div>
      </div>
      <div
        className={
          "z-[99] bg-white w-full px-5 pt-4 pb-[30px] fixed bottom-0 left-0 !font-semibold flex flex-col gap-4"
        }
      >
        <Button
          type="primary"
          size="lg"
          clickHandler={() => {
            clickHandler();
          }}
          text={"다음"}
        />
      </div>
      {leaveModalOpen && (
        <AccountConnectLeaveModal
          setModalOpen={setLeaveModalOpen}
          isModalOpen={leaveModalOpen}
          leaveHandler={() => {
            setIsObligationTermsModalOpen(false);
          }}
          text="지금 나가면 주식을 거래할 수 없어요"
        />
      )}
    </main>
  );
}

export default ObligationTermsNoti;
